import React from 'react'
import Breadcrumb from '../../components/breadcrumb'

import Layout from '../../components/layout'
import SEO from '../../components/seo'
import SectorPage from '../../components/sectorPage'

const CarPage = ({location}) => {
  return (
    <Layout year="2021" simpleHeader={true} url="/2021/automobile" type="sector">
      <SEO 
        title="Classement des meilleurs sites de constructeurs automobiles - 2021"
        description="Quels sont les meilleurs sites de constructeurs automobiles de l'Observatoire de l'impact positif ? Voici les résultats pour Peugeot, Renault, Citroen, DS et Alpine."
        path="/2021/automobile"
        year="2021" />
      
      <Breadcrumb url="/2021/automobile" label="Automobile" year="2021" />

      <SectorPage slug="car" type="sector" year="2021" />
    </Layout>
  )
  }

export default CarPage

